import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import MineIndex from './index';
import HotelFormView from '../Home/View/FormView/HotelFormView';
import RegisterFormView from '../Home/View/FormView/RegisterFormView';
import PlainFormView from '../Home/View/FormView/PlainFormView';
import JourneyFormView from '../Home/View/FormView/JourneyFormView';
import Hotel from './Hotel'
import Plane from './Plane'
import Trip from './Trip'
import Meet from './meet'


export default () => {
  return (
    <>
      <Switch>
        {/* 首页 */}
        <Route
          path="/mine/index/:id"
          render={(props: any) => {
            // document.title = "会佰分-首页";
            return <MineIndex {...props} />;
          }}
        />
        {/* 注册 */}
        <Route
          path="/mine/register/:id"
          render={(props: any) => {
            // document.title = "会佰分-首页";
            return <RegisterFormView {...props} />;
          }}
        />

        {/* 我的酒店 */}
        <Route
          path="/mine/hotel/index/:id"
          render={(props: any) => {
            return <Hotel {...props} />;
          }}
        />
        {/* 酒店注册 */}
        <Route
          path="/mine/hotel/:id/:formid"
          render={(props: any) => {
            return <HotelFormView {...props} />;
          }}
        />
        <Route
          path="/mine/hotel/:id"
          render={(props: any) => {
            return <HotelFormView {...props} />;
          }}
        />


        <Route
          path="/mine/plane/index/:id"
          render={(props: any) => {
            return <Plane {...props} />;
          }}
        />

        {/* 接送机注册 */}
        <Route
          path="/mine/plain/:id/:formid"
          render={(props: any) => {
            return <PlainFormView {...props} />;
          }}
        />

        <Route
          path="/mine/plain/:id"
          render={(props: any) => {
            return <PlainFormView {...props} />;
          }}
        />
        {/* 行程注册 */}
        <Route
          path="/mine/joruney/:id/:formid"
          render={(props: any) => {
            return <JourneyFormView {...props} />;
          }}
        />
        <Route
          path="/mine/joruney/:id"
          render={(props: any) => {
            return <JourneyFormView {...props} />;
          }}
        />

        <Route
          path="/mine/trip/index/:id"
          render={(props: any) => {
            return <Trip {...props} />;
          }}
        />
        <Route
          path="/mine/meet/index/:id"
          render={(props: any) => {
            return <Meet {...props} />;
          }}
        />

        {/* <Redirect from="/mine" to="/mine/index/null" /> */}
      </Switch>
    </>
  )
}